import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';


@Component({
	selector: 'cp-icon-text-row',
	templateUrl: './icon.text.row.html',
	styleUrls: ['./icon.text.row.scss'],
	encapsulation:ViewEncapsulation.Emulated,
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class IconTextRowComponent{
	@Input() iconClass: string;
	@Input() text: string;
	@Input() additionalText: string;
}
